module.exports = __webpack_public_path__ + "img/section-1_bottom_img_server.ccb1d0d7.png";